<script>
import pagination from "@/mixins/pagination";
import taskDefaultList from "@/mixins/taskDefaultList";
import BaseSubNav from "@/components/ui/BaseSubNav.vue";

export default {
  name: "AppointmentDefaultList",

  mixins: [pagination, taskDefaultList],

  components: {
    BaseSubNav,
  },

  data() {
    return {
      configType: "appointments",
    };
  },
};
</script>

<template lang="pug">
  section
    BaseSubNav(
      navigationType="treatment"
      :showNavigation="true"
    )
      template(#title)
        | Recordatorios
        small(v-if="pagination.total")  ({{ pagination.total }})
      template(#actions)
        el-input.search__input(prefix-icon="el-icon-search" v-on:input="debounceInput" v-model="searchInput" placeholder="Buscar" :clearable="true")
        router-link.button.button--blue(:to="{name: 'create-task', params: { taskType: 'appointments' }}" v-auth="'task-default.create'")
          micon(name="add_circle_outline").button__icon
          span.button__text Nuevo Recordatorio
    .box.box--with-subnav
      .box__content--stretch
        table
          thead
            tr
              th Nombre del médico
              th Especialidad
              th Acciones
          tbody
            spinner(v-if="isLoading && !tasks.length")
            tr(v-else, v-for="a in tasks", :key="a._id")
              td {{ a.name }}
              td {{ a.description }}
              td.actions
                .actions-container
                  button.button.button--action(@click="edit(a._id)")
                    micon(name="edit")
                  button.button.button--action(@click="remove(a)")
                    micon(name="delete_forever")

      pagination(
        :isLoading="isLoading"
        :limit="pagination.limit",
        :total="pagination.total",
        @pagination="setPagination"
      )
</template>
